import { styled } from '../theme';
import Small from './Small';

type Props = {
    status: 'error' | 'warning' | 'success';
};

const FieldStatusText = styled(Small.withComponent('div'))<Props>(({ theme, status }) => ({
    color: theme.color[status],
    fontWeight: theme.typography.fontWeight.medium,
}));

export default FieldStatusText;
